import React, { useState } from 'react';
import Select from 'react-select';

const ReceivedPaymentModal = ({ isOpen, setIsOpen }) => {
    const [step, setStep] = useState(1); // Step management
    const [paymentType, setPaymentType] = useState(null); // Store selected payment type

    if (!isOpen) return null;

    const students = [
        { value: 'student1', label: 'Student 1' },
        { value: 'student2', label: 'Student 2' },
    ];

    const paymentMethods = [
        { value: 'credit', label: 'Credit Card' },
        { value: 'debit', label: 'Debit Card' },
        { value: 'paypal', label: 'PayPal' },
    ];

    const handleNextStep = (type) => {
        setPaymentType(type);
        setStep(2);
    };

    const handleBack = () => setStep(1);

    const handleClose = () => {
        setStep(1); // Reset to step 1 on close
        setIsOpen(false);
    };

    return (
        <div className="custom-modal-overlay" onClick={handleClose}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                {step === 1 && (
                    <>
                        <h2 className="oms-modal-title">Select Payment Type</h2>
                        <div className="oms-form-actions" style={{ justifyContent: 'center', gap: '20px' }}>
                            <button type="button" onClick={() => handleNextStep('full')}>
                                Full Payment
                            </button>
                            <button type="button" onClick={() => handleNextStep('partial')}>
                                Partial Payment
                            </button>
                        </div>
                    </>
                )}
                {step === 2 && (
                    <>
                        <h2 className="oms-modal-title">Enter Payment Details</h2>
                        <form className="oms-modal-form">
                            <div className="oms-form-group">
                                <label htmlFor="student" className="oms-form-label">
                                    Select Student
                                </label>
                                <Select options={students} placeholder="Select a student" />
                            </div>
                            <div className="oms-form-group">
                                <label htmlFor="amount" className="oms-form-label">
                                    {paymentType === 'full' ? 'Full Amount' : 'Partial Amount'}
                                </label>
                                <input
                                    type="number"
                                    id="amount"
                                    placeholder={
                                        paymentType === 'full' ? 'Enter full amount' : 'Enter partial amount'
                                    }
                                />
                            </div>
                            {paymentType === 'full' && (
                                <div className="oms-form-group">
                                    <label htmlFor="duration" className="oms-form-label">
                                        Duration (in months)
                                    </label>
                                    <input
                                        type="number"
                                        id="duration"
                                        placeholder="Enter duration in months"
                                    />
                                </div>
                            )}
                            <div className="oms-form-group">
                                <label htmlFor="paymentMethod" className="oms-form-label">
                                    Payment Method
                                </label>
                                <Select options={paymentMethods} placeholder="Select payment method" />
                            </div>
                            <div className="oms-form-actions">
                                <button type="button" onClick={handleBack}>
                                    Back
                                </button>
                                <button type="submit">Submit</button>
                            </div>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
};

export default ReceivedPaymentModal;
